import { render, staticRenderFns } from "./task-list-dropdown.vue?vue&type=template&id=80d6bd1a&scoped=true"
import script from "./task-list-dropdown.vue?vue&type=script&lang=js"
export * from "./task-list-dropdown.vue?vue&type=script&lang=js"
import style0 from "./task-list-dropdown.vue?vue&type=style&index=0&id=80d6bd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6bd1a",
  null
  
)

export default component.exports